module.exports = __webpack_public_path__ + "media/garden_front.56a85514.svg";